import { Plus, Trash, DotsSixVertical } from '@phosphor-icons/react';

import type { CreateSectionPayload } from '@/types/form';

import styles from './SectionEditor.module.css';

interface SectionEditorProps {
    section: CreateSectionPayload;
    sectionIndex: number;
    isSelected: boolean;
    onSelect: () => void;
    onUpdate: (partial: Partial<Pick<CreateSectionPayload, 'title' | 'description'>>) => void;
    onDelete: () => void;
    onAddField: () => void;
    canDelete: boolean;
}

export function SectionEditor({
    section,
    sectionIndex,
    isSelected,
    onSelect,
    onUpdate,
    onDelete,
    onAddField,
    canDelete,
}: SectionEditorProps) {
    return (
        <div
            className={`${styles.section} ${isSelected ? styles.selected : ''}`}
            onClick={onSelect}
            role="button"
            tabIndex={0}
            aria-label={`Seccion ${sectionIndex + 1}${section.title ? `: ${section.title}` : ''}`}
            aria-pressed={isSelected}
            onKeyDown={(e) => e.key === 'Enter' && onSelect()}
        >
            <div className={styles.dragHandle} aria-hidden="true">
                <DotsSixVertical size={16} />
            </div>

            <div className={styles.body}>
                <div className={styles.sectionNumber}>Seccion {sectionIndex + 1}</div>
                <input
                    className={styles.titleInput}
                    value={section.title}
                    onChange={(e) => onUpdate({ title: e.target.value })}
                    placeholder="Titulo de la seccion (opcional)"
                    maxLength={200}
                    onClick={(e) => e.stopPropagation()}
                />
                <div className={styles.fieldCount}>
                    {section.fields.length} {section.fields.length === 1 ? 'pregunta' : 'preguntas'}
                </div>
            </div>

            <div className={styles.actions}>
                <button
                    type="button"
                    className={styles.addBtn}
                    onClick={(e) => { e.stopPropagation(); onAddField(); }}
                    aria-label="Agregar pregunta"
                    title="Agregar pregunta"
                >
                    <Plus size={14} />
                </button>
                {canDelete && (
                    <button
                        type="button"
                        className={styles.deleteBtn}
                        onClick={(e) => { e.stopPropagation(); onDelete(); }}
                        aria-label="Eliminar seccion"
                        title="Eliminar seccion"
                    >
                        <Trash size={14} />
                    </button>
                )}
            </div>
        </div>
    );
}
